module.exports = __webpack_public_path__ + "static/img/company.519afdd6.jpg";